import { useSelector } from 'react-redux';
import { getBrandKitId } from 'ContentData/selectors/branding';
import Routes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { LinkIcon, UnlinkIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import InheritanceTypes from 'ContentUtils/constants/CustomWidgetInheritanceTypes';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.${key}`;
const FieldInheritanceIcon = ({
  inheritedValue,
  isDefaultValue,
  onResetClick,
  onUnlinkClick,
  scrollToField,
  themePath
}) => {
  const {
    inheritanceType,
    inheritanceFieldKey,
    inheritanceFieldLabel
  } = inheritedValue || {};
  const brandKitId = useSelector(getBrandKitId);
  if (!inheritanceType) return null;
  let tooltipTitle;

  // If default value was overridden, display "Reset" tooltip
  if (!isDefaultValue) {
    tooltipTitle = inheritanceType === InheritanceTypes.brandSettings ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('inheritanceTooltip.reset.brandSettings')
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('inheritanceTooltip.reset.default')
    });
    // Link to brand kit if inheriting from brand settings
  } else if (inheritanceType === InheritanceTypes.brandSettings) {
    tooltipTitle = /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('inheritanceTooltip.brandSettings_jsx'),
      options: {
        href: Routes.brandSettings(brandKitId)
      },
      elements: {
        Link
      }
    });
    // If inheriting from theme settings and theme path is given, link to theme editor
  } else if (inheritanceType === InheritanceTypes.theme && themePath) {
    tooltipTitle = inheritanceFieldLabel ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('inheritanceTooltip.themeEditorField_jsx'),
      options: {
        href: Routes.themeEditor(themePath, {
          scrollToField: inheritanceFieldKey.join('.')
        }),
        inheritanceFieldLabel
      },
      elements: {
        Link
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('inheritanceTooltip.themeEditor_jsx'),
      options: {
        href: Routes.themeEditor(themePath)
      },
      elements: {
        Link
      }
    });
    // Otherwise, if inheriting from another field display which field that is
  } else if (inheritanceFieldLabel) {
    tooltipTitle = scrollToField ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: i18nKey('inheritanceTooltip.field_jsx'),
      options: {
        onClick: () => {
          scrollToField({
            fieldKey: inheritanceFieldKey
          });
        },
        inheritanceFieldLabel
      },
      elements: {
        Link
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('inheritanceTooltip.field'),
      options: {
        inheritanceFieldLabel
      }
    });
  }
  return tooltipTitle ? /*#__PURE__*/_jsx(Flex, {
    inlineSize: "18px",
    children: /*#__PURE__*/_jsx(IconButton, {
      onClick: isDefaultValue ? onUnlinkClick : onResetClick,
      size: "md",
      tooltip: tooltipTitle,
      use: "link",
      marginInlineStart: "100",
      children: isDefaultValue ? /*#__PURE__*/_jsx(LinkIcon, {}) : /*#__PURE__*/_jsx(UnlinkIcon, {})
    })
  }) : null;
};
export default FieldInheritanceIcon;